/**
 * 可在服务端 / 构建阶段安全使用的配置入口（无 Hooks、无 DOM 依赖）。
 * 适用于 Next.js App Router 根 layout 中调用 mergeModalType 等纯配置逻辑。
 */
export { mergeModalType, getModalTypeMap } from './constants/modalTypes';
export { isBrowser } from './env';
export type { MergeModalTypeInput, MergeableModalTypeMap } from './types/modal';
